<template>
    <div :class="['booking',{'booking2': action == 2},language]">
        <img class="s7-title" :src="require(`@/assets/${language}/7-1/7_1tit.png`)" alt="" v-if="action == 2">

        <p class="w1">{{ i18n('booking_title') }}</p>

        <div class="email">
            <input 
                v-model="email" 
                :class="['email_ipt',{'email_ipt2': action == 2}]" 
                type="email" 
                :placeholder="i18n('enterEmail')" 
                @blur="checkEmail"
                @input="showErrmsg1 = false"
            />
            <div :class="['yuyue2',language]" v-if="action == 2" @click="yuyue">提交</div>
            <div class="errmsg" v-if="showErrmsg1">{{ errmsg }}</div>
        </div>
        <div :class="['phone',{'phone2': action == 2}]">
            <div :class="['area_select',{'active': area_index != null}]" @click.stop="showSelect = !showSelect">
                {{area_index != null ? select_area[area_index].text : '區號'}} <i></i>
            </div>
            <ul class="select_area" v-if="showSelect">
                <li :class="{'active': area_index == i}" v-for="(item,i) in select_area" :key="i" @click="selectArea(i)">{{ item.text }}</li>
            </ul>
            <input type="tel" placeholder="請輸入手機號碼" v-model="phone" @input="showErrmsg4 = false" @blur="checkPhone" />
            <div class="errmsg err2" v-if="showErrmsg4">{{ errmsg4 }}</div>
        </div>
        <p class="agree" @click="agree1 = !agree1;showErrmsg2 = false">
            <span :class="['check',{'checked': agree1 == true}]"></span>{{ i18n('agree1') }}<span class="errmsg" v-if="showErrmsg2">{{ i18n('agreefirst') }}</span>
        </p>
        <p class="agree">
            <span :class="['check',{'checked': agree2 == true}]" @click="agree2 = !agree2;showErrmsg3 = false"></span>
            <span @click="agree2 = !agree2;showErrmsg3 = false">{{ i18n('agree2_1') }}</span><a href="https://chuang-games.com/qjsj-useragreement.html" target="_blank">{{ i18n('agree2_2') }}</a>{{ i18n('agree2_3') }}<a href="https://chuang-games.com/qjsj-privacypolicy.html" target="_blank">{{ i18n('agree2_4') }}</a>{{ i18n('agree2_5') }}
            <span class="errmsg" v-if="showErrmsg3">{{ i18n('agreefirst') }}</span>
        </p>

        <div :class="['yuyue',language]" v-if="action == 1" @click="yuyue">{{ i18n('ljyy') }}</div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: ['action','i18n'],

    computed: {
        ...mapGetters(['language'])
    },
    data() {
        return {
            email: '',
            errmsg: '',
            showErrmsg1: false,
            showErrmsg2: false,
            showErrmsg3: false,
            agree1: true,
            agree2: true,
            area_index: null,
            select_area: [
                {
                    num: '886',
                    text: '台灣 +886'
                },
                {
                    num: '852',
                    text: '香港 +852'
                },
                {
                    num: '853',
                    text: '澳門 +853'
                },
            ],
            phone: '',
            showSelect: false,
            showErrmsg4: false,
            errmsg4: ''
        }
    },
    methods: {
        checkEmail() {
            if(this.email == '') {
                this.errmsg = this.i18n('enterEmail')
                this.showErrmsg1 = true
                //this.$message.error(this.i18n('enterEmail'))
                return false
            }else {
                const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if (!reg.test(this.email)) {
                    //this.$message.error(this.i18n('validemail'))
                    this.errmsg = this.i18n('validemail')
                    this.showErrmsg1 = true
                    return false
                }else {
                    this.showErrmsg1 = false
                    return true
                }
            }
        },
        yuyue() {
            if(!this.checkEmail()) return
            if(!this.checkPhone()) return
            if(!this.agree1) {
                //this.showErrmsg2 = true
                this.$message.error(this.i18n('agreefirst'))
                return
            }
            if(!this.agree2) {
                this.$message.error(this.i18n('agreefirst'))
                return
            }
            
            this.$http.post('MlbbReservation/create',{
                email: this.email,
                phone_code: this.select_area[this.area_index].num,
                phone: this.phone
            }).then(res => {
                if(res.code == 0) {
                    this.$emit('openyySuccess')
                    fbq('track', 'CompleteRegistration');
                    ttq.track('CompleteRegistration');
                    dataLayer.push({'event': 'submit successfully'});
                }else {
                    this.$message.error(res.msg)
                }
            })
        },
        selectArea(i) {
            this.area_index = i
            this.showErrmsg4 = false
            this.showSelect = false
        },
        closeSelect() {
            this.showSelect = false
        },
        checkPhone() {
            if(this.area_index == null) {
                this.errmsg4 = '請選擇區號'
                this.showErrmsg4 = true
                return false
            }else {
                if(this.phone == '') {
                    this.errmsg4 = '請輸入手機號碼'
                    this.showErrmsg4 = true
                    return false
                }
                if(this.select_area[this.area_index].num == 886) {
                    const reg = /^09[0-9]{8}$/
                    if (!reg.test(this.phone)) {
                        this.errmsg4 = '請輸入正確的手機號碼'
                        this.showErrmsg4 = true
                        return false
                    }else {
                        this.showErrmsg4 = false
                        return true
                    }
                }else if(this.select_area[this.area_index].num == 852 || this.select_area[this.area_index].num == 853) {
                    const reg = /^[0-9]{8}$/
                    if (!reg.test(this.phone)) {
                        this.errmsg4 = '請輸入正確的手機號碼'
                        this.showErrmsg4 = true
                        return false
                    }else {
                        this.showErrmsg4 = false
                        return true
                    }
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.s7-title {
    display: block;
    margin: -0.2rem auto 1rem;
    height: .9rem;
    width: auto;
    z-index: 2;
    position: relative;
}
.w1 {
    font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
    text-align: center;
    font-weight: 700;
    font-size: .36rem;
    color:#723F31;
    margin-bottom: .15rem;
}
.email {
    display: flex;
    align-items: center;
    margin-bottom: .28rem;
    padding-left: .03rem;
    position: relative;
    .email_ipt {
        width: 9.26rem;
        height: .52rem;
        margin: 0 auto;
        border: none;
        outline: none;
        background-color: transparent;
        background: url(../../assets/zh/1-8/border.png) 0 0 / 100% 100% no-repeat;
        padding: 0 .12rem;
        font-size: .24rem;
        color: #000;
        text-align: center;
        &::placeholder {
            color: #E4C4B1;
        }
        &.email_ipt2 {
            padding: 0 3rem 0 .7rem;
            text-align: start;
            position: absolute;
            width: 100%;
            height: 100%;
            background: url(../../assets/zh/1-8/border2.png) 0 0 / 100% 100% no-repeat;
        }
    }
    .yuyue2 {
        position: absolute;
        right: 0;
        min-width: 2.75rem;
        padding: 0 0.2rem;
        height: .68rem;
        line-height: .68rem;
        text-align: center;
        background: url(../../assets/zh/1-8/yybtn_bg.png) 0 0 / 100% 100% no-repeat;
        user-select: none;
        cursor: pointer;
        font-size: .24rem;
        color: #B04B30;
        font-weight: 700;
        -webkit-tap-highlight-color: transparent;
        &:active {
            opacity: 0.8;
        }
    }
}
.phone {
    display: flex;
    align-items: center;
    width: 9.2rem;
    height: .52rem;
    margin: 0 auto 0.3rem;
    background: url(../../assets/zh/1-8/phone_border.png) 0 0 / 100% 100% no-repeat;
    color: #777;
    font-size: .24rem;
    position: relative;
    .area_select {
        width: 2.55rem;
        text-align: start;
        position: relative;
        cursor: pointer;
        padding-left: 0.8rem;
        -webkit-tap-highlight-color: transparent;
        i {
            width: .12rem;
            height: .12rem;
            border-right: 2px solid #a87e4c;
            border-bottom: 2px solid #a87e4c;
            position: absolute;
            right: .15rem;
            top: 42%;
            transform: translateY(-50%) rotate(45deg);
        }
        &.active {
            color: #000;
        }
    }
    .select_area {
        position: absolute;
        top: .52rem;
        left: .15rem;
        width: 26%;
        border: 1px solid #a10e14;
        background-color: #fff;
        z-index: 10;
        border-radius: .04rem;
        li {
            padding: 0.1rem 0.12rem;
            font-size: .24rem;
            cursor: pointer;
            user-select: none;
            &:hover,
            &.active {
                background-color: #B04B30;
                color: #fff;
            }
        }
    }
    input {
        flex: 1;
        border: none;
        outline: none;
        background-color: transparent;
        color: #000;
        padding: 0 0.4rem;
        font-size: .24rem;
        &::placeholder {
            color: #E4C4B1;
        }
    }
    &.phone2 {
        width: 10.5rem;
        height: 0.8rem;
        background: url(../../assets/zh/1-8/phone_border2.png) 0 0 / 100% 100% no-repeat;
        .area_select {
            width: 2.8rem;
        }
        .select_area {
            top: .8rem;
        }
    }
}
.errmsg {
    position: absolute;
    height: .3rem;
    line-height: .3rem;
    bottom: -0.28rem;
    left: 0.5rem;
    font-size: .2rem;
    color: red;   
    text-align: start;     
}
.agree {
    padding: 0 0.3rem;
    font-size: .2rem;
    color: #723F31;
    margin-bottom: .2rem;
    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
    // justify-content: flex-start;
    cursor: pointer;
    user-select: none;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    a {
        display: inline-block;
        color: #B04B30;
        position: relative;
    }
    .check {
        display: inline-block;
        transform: translateY(0.06rem);
        width: .27rem;
        height: .27rem;
        margin-right: .16rem;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(../../assets/zh/1-8/notselected.png);
        &.checked {
            background-image: url(../../assets/zh/1-8/selected.png);
            position: relative;
            &::after {
                content: '';
                position: absolute;
                top: -0.08rem;
                left: -0.08rem;
                width: .44rem;
                height: .33rem;
                background: url(../../assets/zh/1-8/gou.png) 0 0 / 100% 100% no-repeat;
            }
        }
    }
}
.yuyue {
    margin-top: .4rem;
    margin-left: 3.15rem;
    width: 3.1rem;
    height: .68rem;
    line-height: .68rem;
    text-align: center;
    font-size: .3rem;
    color: #B04B30;
    font-weight: 700;
    background: url(../../assets/zh/1-8/yybtn_bg.png) 0 0 / 100% 100% no-repeat;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    &:active {
        transform: scale(0.98);
    }
    &.en,
    &.in,
    &.fi {
        font-size: .2rem;
    }
    &.en {
        margin-top: .8rem;
    }
}
.booking2 {
    width: 13.39rem;
    min-height: 7.5rem;
    background: url(../../assets/zh/7-1/yy_bg.png) 0 0 / 100% 100% no-repeat;
    padding: 0 1.4rem 1.6rem;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        top: -0.1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 6.71rem;
        height: 1.06rem;
        background: url(../../assets/zh/7-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
        z-index: 1;
    }
    .email {
        height: .82rem;
    }
    .agree {
        padding: 0 .8rem;
    }
    .errmsg {
        left: .2rem;
    }
}
@media screen and (max-width: 751px) {
    .phone {
        width: 5.4rem;
        &.phone2 {
            width: 5.29rem;
            height: 0.7rem;
            .area_select {
                width: 1.4rem;
                padding-left: .2rem;
                font-size: .2rem;
                i {
                    right: .05rem;
                }
            }
            .select_area {
                top: 0.7rem;
                width: 30%;
                li {
                    font-size: .2rem;
                }
            }
        }
    }
}
</style>
